import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext.js';
import { getUserLegalConsents, setUserLegalConsents } from '../../database/firebase.js';
import LegalConsentModal from './LegalConsentModal.jsx';

const LegalConsentGate = () => {
  const { currentUser } = useAuth();
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkConsents = async () => {
      if (!currentUser) {
        setLoading(false);
        return;
      }

      await new Promise(r => setTimeout(r, 400));

      const sessionKey = `legal_consent_checked_${currentUser.uid}`;
      if (sessionStorage.getItem(sessionKey) === 'done') {
        setLoading(false);
        return;
      }

      try {
        const consents = await getUserLegalConsents(currentUser.uid);
        const hasAll = Boolean(
          consents?.tosAccepted && consents?.privacyAccepted && consents?.cookiesAccepted
        );
        setShowModal(!hasAll);
        sessionStorage.setItem(sessionKey, 'done');
      } catch (e) {
        setShowModal(true);
        sessionStorage.setItem(sessionKey, 'done');
      } finally {
        setLoading(false);
      }
    };
    checkConsents();
  }, [currentUser]);

  if (!currentUser) return null;
  if (loading) return null;

  return (
    <LegalConsentModal
      isOpen={showModal}
      onCancel={() => setShowModal(false)}
      onConfirm={async payload => {
        await setUserLegalConsents(currentUser.uid, {
          ...payload,
          acceptedAt: new Date().toISOString(),
        });
        setShowModal(false);
      }}
    />
  );
};

export default LegalConsentGate;
